/** Hosted releases use one stable feed; local desktop builds retain their release channel. */
export function desktopDownloadUrl(hosted: boolean, channel?: string) {
  if (hosted) return "https://tolty.toltiq.io/download";
  return channel === "nightly"
    ? "https://t3.codes/download?channel=nightly"
    : "https://t3.codes/download";
}

/** Stable public landing page, including when the application cannot start. */
export const DESKTOP_DOWNLOAD_URL = desktopDownloadUrl(
  import.meta.env.VITE_TOLT_AGENT_AUTH_ENABLED?.trim().toLowerCase() === "true",
);
